import {createAction, createReducer} from '@reduxjs/toolkit';
import initialstate from '../app/initialstate';

const IS_LOADING = 'app/loading';

/**
 * Action creator to set isLoading store slice
 * @param {Boolean} isLoading Whether the area is loading.
 * @param {Array<string>} areas The loading area keys.
 */
export const setLoading = createAction(IS_LOADING);

export const loadingReducer = createReducer(initialstate.loading, (builder) => {
	builder.addCase(setLoading, (loading, action) => {
		const areas = action.payload.areas;
		const isLoading = action.payload.isLoading;

		if (Array.isArray(areas)) {
			const updatedAreas = areas.reduce((previous, current) => {
				return {...previous, [current]: isLoading};
			}, loading.areas);

			return {
				areas: updatedAreas
			};
		}

		return loading;
	});
});
